.d{display:flex;}